namespace GeniuzPOS.Points {
    export class MemberTypeColumns {
        static columnsKey = 'Points.MemberType';
    }
}
